<script lang="ts" setup></script>

<template>
  <div class="arrow">
    <svg class="arrow__svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="m15,5l7,7-7,7-1.4-1.4,4.58-4.6H2v-2h16.18l-4.6-4.6,1.43-1.4Z" />
    </svg>
  </div>
</template>

<style lang="scss" scoped>
.arrow {
  margin-top: 2px;
  align-items: start;
  width: 40px;
  display: flex;
  justify-content: center;
}
.arrow__svg {
  width: 16px;
  height: 16px;
  fill: rgb(var(--v-theme-on-surface));
}
</style>
